import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'numberDay',
  standalone: false,
})
export class NumberDayPipe implements PipeTransform {

  currentLang: string = 'ja';

  translate: TranslateService;

  constructor(translate: TranslateService) {
    this.translate = translate;
    this.currentLang = this.translate.currentLang;
    console.log('NumberDayPipe.constructor lang=-' + this.translate.currentLang + '-');
  }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.RESERVATION_NUMBER_DAY_00:
        type = this.translate.instant('当日');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_01:
        type = this.translate.instant('1日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_02:
        type = this.translate.instant('2日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_03:
        type = this.translate.instant('3日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_04:
        type = this.translate.instant('4日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_05:
        type = this.translate.instant('5日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_06:
        type = this.translate.instant('6日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_07:
        type = this.translate.instant('7日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_08:
        type = this.translate.instant('8日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_09:
        type = this.translate.instant('9日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_10:
        type = this.translate.instant('10日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_11:
        type = this.translate.instant('number-day.DAY_11_BEFORE');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_12:
        type = this.translate.instant('12日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_13:
        type = this.translate.instant('13日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_14:
        type = this.translate.instant('14日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_15:
        type = this.translate.instant('15日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_16:
        type = this.translate.instant('16日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_17:
        type = this.translate.instant('17日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_18:
        type = this.translate.instant('18日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_19:
        type = this.translate.instant('19日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_20:
        type = this.translate.instant('20日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_21:
        type = this.translate.instant('21日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_22:
        type = this.translate.instant('22日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_23:
        type = this.translate.instant('23日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_24:
        type = this.translate.instant('24日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_25:
        type = this.translate.instant('25日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_26:
        type = this.translate.instant('26日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_27:
        type = this.translate.instant('27日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_28:
        type = this.translate.instant('28日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_29:
        type = this.translate.instant('29日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_30:
        type = this.translate.instant('30日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_31:
        type = this.translate.instant('31日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_32:
        type = this.translate.instant('32日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_33:
        type = this.translate.instant('33日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_34:
        type = this.translate.instant('34日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_35:
        type = this.translate.instant('35日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_36:
        type = this.translate.instant('36日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_37:
        type = this.translate.instant('37日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_38:
        type = this.translate.instant('38日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_39:
        type = this.translate.instant('39日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_40:
        type = this.translate.instant('40日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_41:
        type = this.translate.instant('41日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_42:
        type = this.translate.instant('42日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_43:
        type = this.translate.instant('43日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_44:
        type = this.translate.instant('44日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_45:
        type = this.translate.instant('45日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_46:
        type = this.translate.instant('46日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_47:
        type = this.translate.instant('47日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_48:
        type = this.translate.instant('48日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_49:
        type = this.translate.instant('49日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_50:
        type = this.translate.instant('50日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_51:
        type = this.translate.instant('51日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_52:
        type = this.translate.instant('52日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_53:
        type = this.translate.instant('53日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_54:
        type = this.translate.instant('54日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_55:
        type = this.translate.instant('55日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_56:
        type = this.translate.instant('56日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_57:
        type = this.translate.instant('57日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_58:
        type = this.translate.instant('58日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_59:
        type = this.translate.instant('59日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_60:
        type = this.translate.instant('60日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_61:
        type = this.translate.instant('61日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_62:
        type = this.translate.instant('62日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_63:
        type = this.translate.instant('63日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_64:
        type = this.translate.instant('64日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_65:
        type = this.translate.instant('65日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_66:
        type = this.translate.instant('66日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_67:
        type = this.translate.instant('67日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_68:
        type = this.translate.instant('68日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_69:
        type = this.translate.instant('69日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_70:
        type = this.translate.instant('70日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_71:
        type = this.translate.instant('71日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_72:
        type = this.translate.instant('72日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_73:
        type = this.translate.instant('73日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_74:
        type = this.translate.instant('74日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_75:
        type = this.translate.instant('75日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_76:
        type = this.translate.instant('76日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_77:
        type = this.translate.instant('77日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_78:
        type = this.translate.instant('78日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_79:
        type = this.translate.instant('79日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_80:
        type = this.translate.instant('80日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_81:
        type = this.translate.instant('81日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_82:
        type = this.translate.instant('82日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_83:
        type = this.translate.instant('83日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_84:
        type = this.translate.instant('84日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_85:
        type = this.translate.instant('85日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_86:
        type = this.translate.instant('86日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_87:
        type = this.translate.instant('87日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_88:
        type = this.translate.instant('88日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_89:
        type = this.translate.instant('89日前');
        break;
      case AppConst.RESERVATION_NUMBER_DAY_90:
        type = this.translate.instant('90日前');
        break;
      default:
        type = '';
        break;
    }
    return type;
  }

}
